import React from "react";
import PropTypes from "prop-types";
import { AppUtils } from "@src/utils";
import { useAuthContext } from "@src/context";
import { useToastContext } from "@src/context/toastContext";
import AdminHooks from "@src/context/hooks/adminHooks";
import {
  BackButton,
  Button,
  CustomerDropDown,
  DropDown,
  FormInput,
  Loader,
  Modal,
  TabSelector,
  Tag,
} from "@src/components/atoms";
import ErrorPage from "@src/components/layout/ErrorPage";
import { CardContainer } from "@src/components/cards";
import { InAppNotificationViewModal } from "@src/components/cards/operator/InAppNotificationViewModal";
import NotificationDetailModal from "./NotificationDetailModal";
import { UsersSection } from "../shared/UsersSection";

const OperatorSignupLinkCard = ({ operator, customerCode, operatorCode }) => {
  const auth = useAuthContext();
  const alreadySignedUp = operator.appUserId != null;

  const {
    data: signupLink,
    isPending: isPendingSignupLink,
    isError: isErrorSignupLink,
    //error: errorAll,
  } = AdminHooks.useGetOperatorSignupLink(
    auth.activeRole,
    customerCode,
    operatorCode,
    alreadySignedUp,
  );
  const { showToast } = useToastContext();

  return (
    <CardContainer
      thickBorderColor="primary"
      bgColor="primary-100"
      padding={2}
      flexibleHeight={true}
    >
      <span>Signup Link:</span>
      {alreadySignedUp ? (
        <Tag color="green">
          user has already signed up/registered for the app
        </Tag>
      ) : isPendingSignupLink ? (
        <Loader />
      ) : isErrorSignupLink ? (
        "error fetching signup link"
      ) : !signupLink ? (
        <Tag color="yellow">No signup link found</Tag>
      ) : (
        <div className="flex flex-row items-center gap-2">
          {operator.active == false && (
            <Tag color="yellow">User is inactive</Tag>
          )}
          <textarea
            type="text"
            readOnly
            className="border p-2 text-sm flex-grow"
          >
            {signupLink}
          </textarea>

          <div className="w-32">
            <Button
              onClick={() => {
                navigator.clipboard.writeText(signupLink);
                showToast("Copied to clipboard!");
              }}
              padding={false}
              secondary
            >
              Copy
            </Button>
          </div>
        </div>
      )}
    </CardContainer>
  );
};
export default OperatorSignupLinkCard;
